import React, { useState, useEffect, useContext } from 'react'
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { initialAllOptionPromises } from '../../../../helper/utils';
import { AuthContext } from '../../../../hooks/context/authContext';
import { useSubmitForm } from '../../../../hooks/useSubmitForm/useSubmitForm';
import { usePropsInputs } from '../../../../hooks/useProps/usePropsInput';
import { usePropsSelect } from '../../../../hooks/useProps/usePropsSelect';
import { useManageGetRequest } from '../../../../hooks/useManageGetRequest/useManageGetRequest';
import { useGetOptionsSelect } from '../../../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import GenericUploadFileV2 from '../../../../components/GenericUploadFile/GenericUploadFileV2';
import { downloadFile } from '../../../../consumers/backendConsumer';
import InputEditorHtml from '../../../../components/modalComponents/InputEditorHtml';
import InputUploadFile from '../../../../components/modalComponents/InputUploadFile';
import InputSelect from '../../../../components/modalComponents/InputSelect';
import { DivInput } from '../../../../components/atoms/DivInput';
import SlideButton from '../../../../components/atoms/SlideButton';
import ModalForm from '../../../../components/modalComponents/ModalForm';
import InputText from '../../../../components/modalComponents/InputText';
import { getAllCargosAPI, getEditPerfilPuestoAPI, saveEditPerfilPuestoAPI } from '../../../../consumers/backendApisUrls';

const EditarPerfilPuesto = ({ toggleModal, refreshPage, idPerfilPuesto }) => {

  const SECTION_NAME = "editarPerfilPuesto";
  const VALID_EXTENSIONS = ["pdf"];
  const KEYS_DROPDOWN = {cargo: "IdCargo"};
  const KEYS = ["NombrePerfilPuesto", "IdCargo", "LinkAccesoPerfil", "Funciones", "File"];

  const [formValues, setFormValues] = useState({});
  const [dropdowns, setDropowns] = useState([]);
  const [buttonState, setButtonState] = useState(false);

  const [commomProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [selectProps] = usePropsSelect(dropdowns, formValues, setFormValues, SECTION_NAME);

  const [getOptions] = useGetOptionsSelect();
  const [submitForm] = useSubmitForm();
  const [executeGet] = useManageGetRequest();

  const initialPromises = () => {
    return [
      getOptions(getAllCargosAPI())
    ]
  }

  const init = async () => {
    manageSearch();
    initialAllOptionPromises(initialPromises, Object.values(KEYS_DROPDOWN), setDropowns);
  }

  const manageSearch = async () => {
    const api = getEditPerfilPuestoAPI(idPerfilPuesto);
    await executeGet(api, (res) => setFormValues(res.data));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const api = saveEditPerfilPuestoAPI();
    await submitForm(KEYS, api, formValues, SECTION_NAME, successSubmitCallback);
  }

  const successSubmitCallback = () => {
    toggleModal();
    refreshPage();
  }

  const handleUploadFile = (res) => {
    setFormValues(lastData => ({...lastData, File: res}));
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <ModalForm onSubmit={handleSubmit} showModal={toggleModal} titulo="Editar Perfil" width="750px">
      <InputText isRequired label='Nombre perfil de puesto' {...commomProps('NombrePerfilPuesto')}/>
      <InputSelect isRequired label='Cargo' {...selectProps('IdCargo')}/>
      <InputTwoOptions label={buttonState ? "Archivo" : "Url"} {...commomProps(buttonState ? "File" : "LinkAccesoPerfil", buttonState ? ["LinkAccesoPerfil"] : ["File"])} buttonState={buttonState} setButtonState={setButtonState}/>
      <InputEditorHtml label='Funciones (HTML)' {...commomProps('Funciones')} direction='column'/>
    </ModalForm>
  )
}

export default EditarPerfilPuesto;

const InputTwoOptions = ({
  label,
  name,
  value,
  onChange,
  sectionName,
  colLabel = 4,
  colInput = 8,
  isIcon,
  placeholder = `Ingresar ${label}`,
  direction = "row",
  buttonState,
  setButtonState
}) => {
  const { state } = useContext(AuthContext);
  const VALID_EXTENSIONS = ["pdf"];

  const setUploadFile = (res) => {
    let data = {
      target: {
        value: res,
        name: name,
      },
    };
    onChange(data);
  }

  return (
    <DivInput direction={direction} colLabel={colLabel} colInput={colInput}>
      <label className='pt-1'>
        <SlideButton value={buttonState} onChange={setButtonState} nameOne="Url" nameTwo="Archivo"/>
      </label>
      <div className={`black-color`}>
        {buttonState
          ? 
          <>
          {value ? 
          <div><a className="mb-0 hand-pointer blue-standard-color d-flex" style={{gap: "15px"}}
          onClick={() => window.open(value)}>
          Archivo
          <FontAwesomeIcon title="Descargar archivo" size="lg" icon={faDownload}/>
          </a></div> :
          value?.Path ? (
            <div className='mt-1'>
              <a
                className="mx-4 hand-pointer blue-standard-color"
                onClick={() => {
                  downloadFile(
                    state.token,
                    value?.Path,
                    value?.OriginalFileName
                  );
                }}
              >
                {isIcon ? 
                  <FontAwesomeIcon title="Descargar archivo" size="lg" icon={faDownload} className="green-innova"/> :
                  <>
                    <FontAwesomeIcon icon="paperclip" transform="left-9" />
                    {value?.OriginalFileName}
                  </>
                }
              </a>
              <FontAwesomeIcon
                icon="trash"
                size="lg"
                title="Eliminar"
                className="hand-pointer blue-standard-color"
                onClick={() => setUploadFile({})}
              />
            </div>
          ) : (
            <div className="">
              <GenericUploadFileV2
                id="UploadFilePerfilPuesto"
                extensionesValidas={VALID_EXTENSIONS}
                uploadFileToS3={setUploadFile}
                textButton="Subir Archivo"
                resetInitialFile={false}
                isIcon={isIcon}
              />
            </div>
          )}
          </>
          : <input
              type="text"
              placeholder={placeholder}
              className="form-control"
              name={name}
              onChange={onChange}
              value={value ?? ""}
            />
        }
        {sectionName && name && (
          <p
            className="ficha-form-input-validation-message"
            id={`ficha-edit-${sectionName}-${name}-validation-message`}
          ></p>
        )}
      </div>
    </DivInput>
  )
}